import { DefaultTheme } from "styled-components";

export const darkTheme: DefaultTheme = {
  bgColor: "#2f3640",
  textColor: "#fff",
  accentColor: "#9c88ff",
  cardBgColor: "transparent"
};

export const lightTheme: DefaultTheme = {
  bgColor: "whitesmoke",
  textColor: "#000",
  accentColor: "#9c88ff",
  cardBgColor: "white"
};
